import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import Site from './site/Site';
import './tokens.css';
import './styles.css';

const root = document.getElementById('root');
if (root) createRoot(root).render(<StrictMode><Site /></StrictMode>);
